import { isRecord } from 'lib/object/objectUtils'
import { readTranslatedString } from 'loyalty/lib/labPayloadUtils'

import { mapLoyaltyWhatsNewCard } from './mapLoyaltyWhatsNewRemoteConfig'
import type {
  IsLoyaltyFeatureFlagEnabled,
  LoyaltyWhatsNewCard,
  LoyaltyWhatsNewViewModel,
} from './types'

const EMPTY_LOYALTY_WHATS_NEW_VIEW_MODEL: LoyaltyWhatsNewViewModel = {
  cards: [],
  hasResolvedRemoteConfig: false,
}

export function resolveLoyaltyWhatsNewRemoteConfig(
  remoteConfig: App.LabRemoteConfigResult | undefined,
  regionCode: string,
  isFeatureFlagEnabled: IsLoyaltyFeatureFlagEnabled = () => false,
  now = new Date(),
): LoyaltyWhatsNewViewModel {
  const { value } = remoteConfig ?? {}
  if (!isRecord(value)) {
    return {
      ...EMPTY_LOYALTY_WHATS_NEW_VIEW_MODEL,
      hasResolvedRemoteConfig: !!remoteConfig,
    }
  }

  const heading = readTranslatedString(value, 'heading')
  const rawCards = Array.isArray(value.cards) ? value.cards : []

  const cards = rawCards.reduce<Array<LoyaltyWhatsNewCard>>((result, item) => {
    const card = mapLoyaltyWhatsNewCard(item, regionCode, now, isFeatureFlagEnabled)
    if (card) result.push(card)
    return result
  }, [])

  return {
    heading,
    cards,
    hasResolvedRemoteConfig: true,
  }
}

export type { LoyaltyWhatsNewCard, LoyaltyWhatsNewViewModel } from './types'
